import { type CurrencyExchange } from "@finway-group/shared/lib/models"
import { type ActionCreator, type Dispatch } from "redux"
import { CurrencyService } from "~Shared/services/currency.service"
import { type ThunkResult } from "~Shared/store"
import { CurrencyActionTypes, type FetchCurrencyExchangeAction } from "~Shared/store/actions/currency/currencyTypes"
import { type CancelFetchAction, FetcherActionTypes } from "../fetcher/fetcherTypes"

export const fetchCurrencyExchange: ActionCreator<ThunkResult<CurrencyExchange>> = () => async (dispatch: Dispatch) => {
    const currencyExchange = await CurrencyService.fetchCurrencyExchange()

    const cancelFetchAction: CancelFetchAction = {
        type: FetcherActionTypes.CANCEL_FETCH,
        isFetchCancelled: true,
    }
    dispatch(cancelFetchAction)

    const fetchCurrencyExchangeAction: FetchCurrencyExchangeAction = {
        type: CurrencyActionTypes.FETCH_CURRENCY_EXCHANGE,
        currencyExchange,
    }
    dispatch(fetchCurrencyExchangeAction)

    return currencyExchange
}
